// extracted by mini-css-extract-plugin
export default {"title":"MZf1R","skeleton-progress":"RiDum"};